import { render, staticRenderFns } from "./LockHistory.vue?vue&type=template&id=145e60b5&scoped=true&"
import script from "./LockHistory.vue?vue&type=script&lang=js&"
export * from "./LockHistory.vue?vue&type=script&lang=js&"
import style0 from "./LockHistory.vue?vue&type=style&index=0&id=145e60b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e60b5",
  null
  
)

export default component.exports